// VideoRegionSelector.jsx - ФИНАЛЬНОЕ ИСПРАВЛЕНИЕ ПЕРЕВОДОВ
import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import videoDiscoveryService from '../../services/videoDiscoveryService';
import './VideoRegionSelector.css';

const VideoRegionSelector = ({
  selectedRegion,
  onChange,
  disabled = false
}) => {
  // ✅ ИСПРАВЛЕНО: Используем правильные namespace'ы как в Research
  const { t, i18n } = useTranslation(['discovery', 'common']);
  const [rawRegions, setRawRegions] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ ФУНКЦИЯ ДЛЯ ПЕРЕВОДА - используем те же ключи что в Research
  const getCountryName = (countryCode, fallbackLabel) => {
    // Пробуем разные варианты ключей
    const keys = [
      `countries.${countryCode}`,     // discovery.json ключи
      `regions.${countryCode}`,       // research.json стиль
      `videoDiscovery.regions.${countryCode}` // полный путь
    ];
    
    for (const key of keys) {
      const translated = t(key, { defaultValue: null });
      if (translated && translated !== key) {
        return translated;
      }
    }
    
    return fallbackLabel;
  };

  // ✅ МЕМОИЗИРОВАННЫЕ ПЕРЕВЕДЕННЫЕ РЕГИОНЫ
  const translatedRegions = useMemo(() => {
    return rawRegions.map(region => ({
      ...region,
      label: region.value === 'all' 
        ? t('countries.all', t('videoDiscovery.filters.regionModes.all', 'Все регионы'))
        : getCountryName(region.value, region.label)
    }));
  }, [rawRegions, t, i18n.language]);

  // ✅ ЗАГРУЗКА РЕГИОНОВ ТОЛЬКО ОДИН РАЗ
  useEffect(() => {
    const loadRegions = async () => {
      try {
        setLoading(true);
        
        const fullData = await videoDiscoveryService.getCategories();
        
        if (fullData && fullData.regions && Array.isArray(fullData.regions)) {
          setRawRegions(fullData.regions);
        } else {
          // Fallback к поддерживаемым регионам БЕЗ переводов
          setRawRegions([
            { value: "all", label: "All Regions" },
            { value: "US", label: "United States" },
            { value: "JP", label: "Japan" },
            { value: "KR", label: "South Korea" },
            { value: "MX", label: "Mexico" },
            { value: "BR", label: "Brazil" },
            { value: "DE", label: "Germany" },
            { value: "GB", label: "United Kingdom" },
            { value: "CA", label: "Canada" },
            { value: "FR", label: "France" },
            { value: "AU", label: "Australia" },
            { value: "CH", label: "Switzerland" }
          ]);
        }
      } catch (error) {
        console.error('Ошибка загрузки регионов:', error);
        setRawRegions([
          { value: "all", label: "All Regions" },
          { value: "US", label: "United States" },
          { value: "RU", label: "Russia" },
          { value: "GB", label: "United Kingdom" }
        ]);
      } finally {
        setLoading(false);
      }
    };

    loadRegions();
  }, []);

  const handleChange = (e) => {
    const value = e.target.value === 'all' ? null : e.target.value;
    onChange(value);
  };

  if (loading) {
    return (
      <div className="video-region-selector">
        <select 
          className="video-region-selector__select" 
          disabled
        >
          <option>{t('common.loading', 'Загрузка...')}</option>
        </select>
      </div>
    );
  }

  return (
    <div className="video-region-selector">
      <select
        id="video-region"
        className="video-region-selector__select"
        value={selectedRegion || 'all'}
        onChange={handleChange}
        disabled={disabled}
      >
        {translatedRegions.map((region) => (
          <option key={region.value} value={region.value}>
            {region.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default VideoRegionSelector;